import React from 'react'
import CloseIconWhiteFilledSVG from "../../../assets/icons/close-icon-white-filled.svg"
export const CloseIconWhiteFilled: React.FC = () => {
  return (
   <img src={CloseIconWhiteFilledSVG} alt="" className="w-[24px] h-[24px] cursor-pointer" />
  )
}
